export default "__VITE_ASSET__e4b23dc6__"